export const BADGE_TONES = {
  slate:
    "border-slate-300 bg-slate-100 text-slate-800 dark:border-slate-700/60 dark:bg-slate-900/40 dark:text-slate-200",
  zinc: "border-zinc-300 bg-zinc-100 text-zinc-900 dark:border-zinc-700/60 dark:bg-zinc-900/40 dark:text-zinc-200",
  red: "border-red-300 bg-red-100 text-red-900 dark:border-red-800/60 dark:bg-red-950/40 dark:text-red-200",
  yellow:
    "border-yellow-300 bg-yellow-100 text-yellow-900 dark:border-yellow-800/60 dark:bg-yellow-950/40 dark:text-yellow-200",
  amber:
    "border-amber-300 bg-amber-100 text-amber-900 dark:border-amber-800/60 dark:bg-amber-950/40 dark:text-amber-200",
  emerald:
    "border-emerald-300 bg-emerald-100 text-emerald-900 dark:border-emerald-800/60 dark:bg-emerald-950/40 dark:text-emerald-200",
  sky: "border-sky-300 bg-sky-100 text-sky-900 dark:border-sky-800/60 dark:bg-sky-950/40 dark:text-sky-200",
  blue: "border-blue-300 bg-blue-100 text-blue-900 dark:border-blue-800/60 dark:bg-blue-950/40 dark:text-blue-200",
  indigo:
    "border-indigo-300 bg-indigo-100 text-indigo-900 dark:border-indigo-800/60 dark:bg-indigo-950/40 dark:text-indigo-200",
  violet:
    "border-violet-300 bg-violet-100 text-violet-900 dark:border-violet-800/60 dark:bg-violet-950/40 dark:text-violet-200",
  cyan: "border-cyan-300 bg-cyan-100 text-cyan-900 dark:border-cyan-800/60 dark:bg-cyan-950/40 dark:text-cyan-200",
  orange:
    "border-orange-300 bg-orange-100 text-orange-900 dark:border-orange-800/60 dark:bg-orange-950/40 dark:text-orange-200",
  rose: "border-rose-300 bg-rose-100 text-rose-900 dark:border-rose-800/60 dark:bg-rose-950/40 dark:text-rose-200",
  muted: "border-border/80 bg-muted/30 text-foreground",
} as const;

export type BadgeTone = keyof typeof BADGE_TONES;

export const ASSORTED_BADGE_TONES = [
  "sky",
  "violet",
  "orange",
  "cyan",
] as const satisfies readonly BadgeTone[];

function normalizeBadgeValue(value: unknown): string {
  if (typeof value !== "string") return "";
  return value
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");
}

function hash32(value: string): number {
  let hash = 0;
  for (const char of value) {
    hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  }
  return hash;
}

export function pickAssortedBadgeClass(
  value: unknown,
  tones: readonly BadgeTone[] = ASSORTED_BADGE_TONES,
  defaultTone: BadgeTone = "slate",
): string {
  const normalized = normalizeBadgeValue(value);
  if (!normalized) return BADGE_TONES[defaultTone];

  const safeTones = tones.length ? tones : ASSORTED_BADGE_TONES;
  const tone = safeTones[hash32(normalized) % safeTones.length] ?? defaultTone;
  return BADGE_TONES[tone] ?? BADGE_TONES[defaultTone];
}
